import { Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import { queryClient } from 'api/client';
import { PublicPostOverview } from 'pages/public/PublicPostOverview';
import AnalyticsPdfExports from 'pages/public/AnalyticsPdfExports';
import { publicPDFReportsRouter } from 'app/modules/public/modules/pdfReports';
import { publicAnalyticsReportsRouter } from 'app/modules/public/modules/analyticsReports';
import { publicAnalyticsExportsRouter } from 'app/modules/public/modules/analyticsExports';
import PublicAppProviders from 'app/modules/public/components/PublicAppProviders';
import { publicFreeToolsRouter } from 'app/modules/public/modules/freeTools';
import { getExternalLoginUrl } from 'app/modules/auth/utils/externalAuthUrls';
import { isSafeReturnPath } from 'app/modules/auth/utils/returnPath';

const RedirectToExternalAuth = () => {
  const returnPath = new URLSearchParams(window.location.search).get(
    'returnPath',
  );
  window.location.href = getExternalLoginUrl(
    isSafeReturnPath(returnPath) ? returnPath : undefined,
  );
  return null;
};

export const publicRouter: RouteObject = {
  path: `/${routeConfig.public.path}`,
  element: (
    <PublicAppProviders queryClient={queryClient}>
      <Outlet />
    </PublicAppProviders>
  ),
  children: [
    {
      index: true,
      element: <RedirectToExternalAuth />,
    },
    {
      path: `${routeConfig.public.routes.post.path}/:postId`,
      element: <PublicPostOverview />,
    },
    {
      path: routeConfig.public.routes.post.path,
      element: <PublicPostOverview />,
    },
    {
      path: routeConfig.public.routes.reports.path,
      element: <AnalyticsPdfExports />,
    },
    publicPDFReportsRouter,
    publicAnalyticsReportsRouter,
    publicAnalyticsExportsRouter,
    publicFreeToolsRouter,
    {
      path: 'login/*',
      element: <RedirectToExternalAuth />,
    },
    {
      path: 'registration/*',
      element: <RedirectToExternalAuth />,
    },
    {
      path: 'forgot-password/*',
      element: <RedirectToExternalAuth />,
    },
  ],
};
